<template>
    <div class="tw-inline-flex">
        <router-link :to="handleRouteTo" class="pill event-category-pill tw-text-white tw-flex tw-items-center cursor-pointer hover:tw-opacity-75" :style="{ backgroundColor: category.color }">
            {{ category.name }}
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'CategoryPill',

        props: {
            category: {
                required: true,
            },
        },

        computed: {
            handleRouteTo() {
                return {
					name: 'events.index',
					query: {
						category: this.category.id
					}
				};
            },
        },
    };
</script>

<style lang="scss" scoped>
    .event-category-pill {
        // @apply tw-pl-4;
        height: 30px;

        .pill-color-indicator {
            left: -1px;
            top: -1px;
            height: calc(100% + 2px);
            width: 5px;
            border-radius: 0.35rem 0 0 0.35rem;
        }
    }
</style>
